export const selectLinkedinPromotionState = (state) => state.linkedinPromotion;
export const selectLinkedinInfo = (state) => state.linkedinPromotion.info;
export const selectLinkedinDeals = (state) => state.linkedinPromotion.deals;
export const selectLinkedinPromotionTotalStats = (state) => state.linkedinPromotion.totalStats || {};
